import moment from 'moment-timezone';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link, withRouter } from 'react-router-dom';
import { Alert, Button, Table } from 'reactstrap';
import ErrorBoundary from './ErrorBoundary';
import NotAuthenticated from './NotAuthenticated';
import * as Accounts from '../store/Accounts';
import * as paths from '../data/Paths';
import * as Patients from '../store/Patients';
import * as utility from '../data/Utility';
import * as sortfilter from '../data/SortFilter';


class ManagePatientsInternal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
			isShowingFilter: false,
			currentFilters: {},
			currentSortDirection: {},
			currentSortingColumn: '',
            allFetched: false
        }
    }

    componentDidMount() {
        Accounts.checkAuthenticated(this.props.accountsState.authenticated, this.props.accountsDispatch);
        this.initialize(null);
    }

    componentDidUpdate(prevProps) {
        this.initialize(prevProps);
    }

    handlePatientSelected(id) {
        const history = this.props.history;
        if (history.location.pathname === paths.managePatients) {
            history.push({
                pathname: paths.patient,
                state: {
                    create: false,
                    editing: false,
                    patientId: id
                }
            });
        }
    }

    initialize(prevProps) {
        const accountsState = this.props.accountsState;
        const authenticated = Accounts.authenticatedAdministrator(accountsState);
        if (Accounts.authenticatedPrevProps(prevProps, authenticated, accountsState.fetching, !this.state.allFetched)) {
            this.props.patientsDispatch.getAll();
            this.setState({
                allFetched: true
            });
        }
    }


	toggleFilter() {
		if ( this.state.isShowingFilter ) {
			this.setState({ currentFilters: {} });
		}
		this.setState({ isShowingFilter: ! this.state.isShowingFilter });
	}

	onSortChange = (currentColumn) => {
		let currentSortDirection = this.state.currentSortDirection;
		let nextSort = 'default';

		switch ( currentSortDirection[currentColumn] ) {
			case "down": nextSort = 'default'; break;
			case "up"  : nextSort = 'down'; break;
			default    : nextSort = 'up'; break;
		}

		let newCurrentSortDirection = {};
		newCurrentSortDirection[currentColumn] = nextSort;

		this.setState({
			currentSortDirection: newCurrentSortDirection,
			currentSortingColumn: currentColumn,
		});
	};

	onFilterChange = (e) => {
		this.setState({ currentFilters: {...this.state.currentFilters, [e.target.name]: e.target.value } });
	};

	ColumnHeader = (props) => {
		sortfilter.filterAssociation[props.recordKey] = props.label;
		let val = this.state.currentFilters[props.label];
		if ( val === undefined ) {
			val = '';
		}
		return <sortfilter.ColHeader value={val} onChange={this.onFilterChange.bind(this)} sortDir={this.state.currentSortDirection} onSortChange={this.onSortChange} showFilter={this.state.isShowingFilter} label={props.label} recordKey={props.recordKey} />
	};


    render() {
        if (!Accounts.authenticatedAdministrator(this.props.accountsState)) {
            return (
                <NotAuthenticated />
            );
        }

        var error = false;
        var message = "";
        var patientList = null;

        const patients = this.props.patientsState.all;
        if (patients != null &&
            patients.map != null) {
            const editTitle = "Edit";
            var rowNum = 1;

            let pList = [...patients].map(patient => {
                const enrollDateTime = utility.formatDisplayDateTime(patient.enrollDateTime);
                var siteName = "";
                var studyName = "";
                const studySite = patient.studySite;

                if (studySite != null) {
                    const site = studySite.site;
                    const study = studySite.study;
                    if (site != null) {
                        siteName = site.name;
                    }
                    if (study != null) {
                        studyName = study.name;
                    }
                }

                const isServiceEvent = studySite && studySite.study && studySite.study.isServiceEvent;
                var showEditButton = true;
                if (isServiceEvent === true) {
                    showEditButton = false;
                }

                return ({
                    ...patient,
                    enrollDateTime: enrollDateTime,
                    showEditButton: showEditButton,
                    siteName: siteName,
                    studyName: studyName,
                });
            });
			pList = sortfilter.filterData(
					[...pList].map( pat => {
						return ({ ...pat,
							procedureDate: moment(pat.procedureDate).isValid() ? moment(pat.procedureDate).format("M/DD/YYYY") : '',
							withdrawalDateTime: moment(pat.withdrawalDateTime).isValid() ? moment(pat.withdrawalDateTime).format("M/DD/YYYY") : '',
						});
					}),
					this.state.currentFilters);

			patientList = [...pList].sort( sortfilter.sortingDetails(this.state.currentSortingColumn,this.state.currentSortDirection).fn ).map(patient => {
                return (
                    <tr key={patient.id} onClick={this.handlePatientSelected.bind(this, patient.id)}>
                        <th scope="row">{rowNum++}</th>
                        <td>{patient.code}</td>
                        <td>{patient.enrollDateTime}</td>
                        <td>{patient.procedureDate}</td>
                        <td>{patient.withdrawalDateTime}</td>
                        <td>{patient.siteName}</td>
                        <td>{patient.studyName}</td>
                        <td>
                            {patient.showEditButton && <Button className="button-inverse" title={editTitle} tag={Link} to={{ pathname: paths.patient, state: { create: false, patientId: patient.id } }}>{editTitle}</Button>}
                        </td>
                    </tr>
                );
            });
        }
        else {
            error = true;
            message = "Error retrieving patients.";
        }

        const alertColor = error ? "danger" : "primary";
        const displayMessage = message !== "";

        return (
            <div>
                <h1>Manage Patients</h1>
                <Button className="button filter_button" id="btnFilter" title="Filter" onClick={this.toggleFilter.bind(this)}> Filter </Button>
                <br />
                {displayMessage && <Alert color={alertColor}>{message}</Alert>}
                <Table striped hover>
                    <thead>
                        <tr>
                            <th>#</th>
							<this.ColumnHeader label="Code" recordKey="code" />
							<this.ColumnHeader label="Enroll DateTime" recordKey="enrollDateTime" />
							<this.ColumnHeader label="Procedure Date" recordKey="procedureDate" />
							<this.ColumnHeader label="Withdrawal Date" recordKey="withdrawalDateTime" />
							<this.ColumnHeader label="Site" recordKey="siteName" />
							<this.ColumnHeader label="Study" recordKey="studyName" />
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {patientList}
                    </tbody>
                </Table>
            </div>
        );
    }
}

const ManagePatientsConnect = withRouter(connect(
    state => ({
        accountsState: state.accounts,
        patientsState: state.patients
    }),
    dispatch => ({
        accountsDispatch: bindActionCreators(Accounts.actionCreators, dispatch),
        patientsDispatch: bindActionCreators(Patients.actionCreators, dispatch)
    })
)(ManagePatientsInternal));

export default class ManagePatients extends React.Component {
    render() {
        return (
            <ErrorBoundary>
                <ManagePatientsConnect />
            </ErrorBoundary>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ManagePatients.js